import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { parseReceptionDesk, type ReceptionDesk } from '@/lib/paymentQueue';

export function receptionDeskQueryKey(clinicId: string | null) {
  return ['reception-desk', clinicId] as const;
}

export function useReceptionDesk(clinicId: string | null, enabled = true) {
  return useQuery({
    queryKey: receptionDeskQueryKey(clinicId),
    enabled: Boolean(clinicId) && enabled,
    queryFn: async (): Promise<ReceptionDesk> => {
      const { data, error } = await supabase.rpc('list_reception_desk', {
        p_clinic_id: clinicId ?? '',
      });
      if (error) throw error;
      return parseReceptionDesk(data);
    },
  });
}
